<template>
  <div class="q-pa-md">
    <div v-if="error">An error occured</div>
    <div v-else>
      <div class="q-mb-md">
        <q-btn
          color="primary"
          :disable="loading"
          label="Add Referrer" @click="$refs.addEditReferrerListDialogRef.openDialog()"
          v-if="canUpdate"
        />
      </div>
      <q-table
        flat
        bordered
        title="Referrer List"
        :data="referrers"
        separator="cell"
        :columns="columns"
        :loading="loading"
        :rows-per-page-options="[0]"
        :pagination.sync="pagination"
      >

        <template v-slot:body="props">
          <q-tr :props="props" :class="{'bg-grey-2':props.rowIndex%2==0}">
            <q-td key="id" :props="props">{{ props.row.id }}</q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="slug" :props="props">{{ props.row.slug }}</q-td>
            <q-td key="depositAmount" :props="props">{{ props.row.depositAmount }}</q-td>
            <q-td key="leadCost" :props="props">{{ props.row.leadCost }}</q-td>
            <q-td key="actions" :props="props" v-if="canUpdate">
              <q-btn
                size="sm"
                flat
                icon="mode_edit"
                class="text-brand1"
                padding="xs"
                @click="$refs.addEditReferrerListDialogRef.openDialog(props.row)">
              </q-btn>

              <q-btn size="sm" flat icon="delete" class="text-brand4" padding="xs">
                <q-menu
                  transition-show="jump-down"
                  transition-hide="jump-up"
                  auto-close
                >
                  <q-list style="min-width: 100px">
                    <q-item clickable>
                      <q-item-section>Cancel</q-item-section>
                    </q-item>
                    <q-item clickable @click="deleteReferrer(props.row.id)">
                      <q-item-section class="text-brand4">Yes Delete</q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn>
            </q-td>
          </q-tr>
        </template>

      </q-table>
    </div>
    <add-edit-referrer-list-dialog
      v-if="canUpdate"
      ref="addEditReferrerListDialogRef"
      @referrerAdded="onReferrerAddition"
    />
  </div>
</template>

<script>
  import graphql from '@client/graphql';
  import { assessPermission } from '@server/lib/permission-helpers';
  import AddEditReferrerListDialog from '@client/components/dialogs/add-edit-referrer-list-dialog';

  const tcolumns = [
    {
      name: 'id',
      label: 'Id',
      align: 'left'
    },
    {
      name: 'name',
      label: 'Name',
      align: 'left'
    },
    {
      name: 'slug',
      label: 'Slug',
      align: 'left'
    },
    {
      name: 'depositAmount',
      label: 'Deposit Amount',
      align: 'left'
    },
    {
      name: 'leadCost',
      label: 'Lead Cost',
      align: 'left'
    }
  ];
  export default {
    metaInfo: {
      title: 'AutoBook Pro - Referral List'
    },
    components: {
      AddEditReferrerListDialog
    },
    apollo: {
      currentUser: {
        query: graphql.queries.currentUser
      },
      referrers: {
        query: graphql.queries.getReferrers,
        watchLoading(isLoading) {
          this.loading = isLoading;
        },
        error(error) {
          this.error = error;
        },
        result(result) {
          if (result.loading) return;
          this.referrals = result.data.referrals;
        }
      }
    },
    data() {
      return {
        loading: false,
        error: null,

        saving: {},

        referrers: [],
        pagination: {
          page: 1,
          rowsPerPage: 0
      }
      };
    },
    computed: {
      canUpdate() {
        return assessPermission.taq.canUpdate(this.currentUser);
      },
      columns() {
        return [
                ...tcolumns,
                ...(
                  this.canUpdate ? [
                    {
                    name: 'actions',
                    label: '',
                    align: 'center'
                    }
                  ] : [])
              ];
      }

    },
    methods: {
    onReferrerAddition() {
      this.$apollo.queries.referrers.refetch();
    },
    async deleteReferrer(id) {
      try {
        await this.$apollo.mutate({
          mutation: graphql.mutations.deleteReferrer,
          variables: { id: Number(id) }
        });
        this.notifyPositive('Referrer Deleted!');
        this.$apollo.queries.referrers.refetch();
      } catch (error) {
        this.notifyNegative(`Error Deleting Referrer! : ${error.message}`);
      }
    }
    }
  };
</script>

<style></style>
